import { render, staticRenderFns } from "./LocalModalWrapper.vue?vue&type=template&id=349b38f6&"
import script from "./LocalModalWrapper.vue?vue&type=script&lang=js&"
export * from "./LocalModalWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports